module.exports = __webpack_public_path__ + "img/apple_store.f3f4804c.png";